import PrivateRoute from "hocs/PrivateRoute";
import InitialPage from "pages/InitialPage";
import NotFoundPage from "pages/NotFoundPage";
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

const PagesSwitcher = React.lazy(() => import("./PagesSwitcher"));

const MainRouter: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route path="/p/home">
          <InitialPage />
        </Route>
        <PrivateRoute lazy path="/p" component={PagesSwitcher} />

        <Route exact path="/">
          <Redirect to="/p/home" />
        </Route>
        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  );
};

export default MainRouter;
